import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/api";
import { useLang } from "@/i18n";
import { BackHome } from "@/components/BackHome";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative">
      <BackHome />
      <div className="w-full max-w-md kc-card p-8" data-testid="forgot-password-card">
        <h1 className="text-3xl font-black uppercase tracking-tight mb-6">{t("forgot.title")}</h1>
        {sent ? (
          <p data-testid="forgot-sent-message" className="text-muted-foreground">{t("forgot.sent")}</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">{t("login.email")}</label>
              <input data-testid="forgot-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="kc-input mt-1" />
            </div>
            {error && <p className="text-sm text-destructive">{error}</p>}
            <button data-testid="forgot-submit-button" type="submit" disabled={loading} className="kc-btn-primary w-full">
              {loading ? t("common.loading") : t("forgot.submit")}
            </button>
          </form>
        )}
        <Link data-testid="back-to-login-link" to="/login" className="block mt-5 text-sm text-muted-foreground hover:text-foreground">
          {t("forgot.back")}
        </Link>
      </div>
    </div>
  );
}
